module.exports = __webpack_public_path__ + "media/components/homepage/static/logo-c427af6b886574c73de264665bd7eafa.png";